/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Marquee from "react-fast-marquee";
import { playSong, setBodyEvents, setEvents, setMixEvents } from '../../common/actions/common.actions';
import scan from "../../../assets/newIcons/gender-neutral-user.png";
import priceTag from "../../../assets/icons/price-tag.svg";
import refreshIcon from "../../../assets/newIcons/rotate-right.png";
import shoeIcon from "../../../assets/newIcons/sports-video-intersound.png";
import prize from "../../../assets/icons/Prize.svg";
import newsPaper from "../../../assets/newIcons/news.png";
import onGoing from "../../../assets/newIcons/play.png";
import soccer from "../../../assets/newIcons/scoreboard.png";
import dashboardService from "../../../api/services/dashboardService";
import withAuth from "../../common/hoc/withAuth";
import SideBarToggle from "../../common/components/sidebar/SideBarToggle";
import Logo from "../../common/components/Logo";
import Popup from "./popup";
import PopupModal from './popupModal';
import { useTranslation } from "react-i18next";
import DarkThemeToggleComponent from "../../../darkThemeToggle";
import football from "../../../assets/newIcons/football2.png";
import HistoryIco from "../../../assets/newIcons/time-machine.png";
import Credit from "../../../assets/newIcons/credit.png";
import { setConfirmData } from '../../common/actions/common.actions';
import { selectLoginData } from "../login/login.actions";
import { IoMdShareAlt } from "react-icons/io";
import LogoIcon from "../../../assets/newIcons/Lucky.png";
import signalRConnection from '../../../signalR/signalRService';

function Dashboard({ setShowSideBar, setIsLoading }) {
  const dispatch = useDispatch();
  const [displayTextArr, setDisplayTextArr] = useState([]);
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userDetails } = useSelector(selectLoginData);
  const [userBalance, setUserBalance] = useState(userDetails?.balance);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const handleChangedBalance = async (user, data) => {
      console.log(`changedBalance Event: ${user}: ${data}`);
      // Handle process after changedBalance
      const userDetailTmp = userDetails || {};
      await updateUserBalance(userDetailTmp);
    };
    signalRConnection.on("changedBalance", handleChangedBalance);
    // Cleanup the event handler when the component unmounts
    return () => {
      signalRConnection.off("changedBalance", handleChangedBalance);
    };
  }, [signalRConnection, userDetails]);

  // add akn for click song
  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleConfirmData = (data) => {
    dispatch(setConfirmData(data));
  };

  const handlePopupToggle = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const removeConfirmData = () => {
    handleConfirmData(null);
  };

  const initData = async () => {
    try {
      // setIsLoading(true);
      await removeConfirmData();
      // const userDetailTmp =
      //   (await JSON.parse(localStorage.getItem("userDetails"))) || {};
      const userDetailTmp = userDetails || {};
      const getDisplayEvents = async () => {
        const data = await dashboardService.getDisplayTextForDashboard().json();
        setDisplayTextArr(data);
      };
      await getDisplayEvents();
      await updateUserBalance(userDetailTmp);
    } catch (error) {
      console.log({ error });
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    initData();
    dispatch(setMixEvents([]));
    dispatch(setBodyEvents([]));
    dispatch(setEvents([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails && storedUserDetails?.balance) {
      setUserBalance(storedUserDetails?.balance);
    }
    console.log('refresh is refresh', refresh);
  }, [refresh]);

  const updateUserBalance = async (userDetailTmp) => {
    if (!userDetailTmp.userId) return;
    try {
      const userId = Number(userDetailTmp.userId);
      const res = await dashboardService.getBalanceForDashboard(userId)
        .then((response) => response.json());
      if (res) {
        if (res && res.userInfo) {
          setUserBalance(res?.userInfo[0]?.balance);
          localStorage.setItem("userDetails", JSON.stringify(res?.userInfo[0]));
        }
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  };

  return (
    <div className="flex flex-row w-full h-screen font-myanmarSansPro bg-white">
      <SideBarToggle setShowSideBar={setShowSideBar} />
        <div className="flex flex-col justify-start items-center h-full w-full md:w-[60vw] lg:w-[30vw] mx-auto px-8 sm:px-4">
        <div className="flex cursor-pointer font-bold justify-end items-center w-full mt-6">
            <img src={refreshIcon} alt='scan'
                className={`w-5 mr-2 ${refresh ? "animate-spin" : ""}`}
                onClick={(e) => {
                    e.stopPropagation();
                    setRefresh(true);
                    setTimeout(() => setRefresh(false), 1500);
                }}
            />

            <div className="text-center text-lg xs:text-xl text-waterDOne">{parseInt(userBalance).toLocaleString()} Ks</div>
                <div className=" cursor-pointer self-start pt-3" onClick={() => {
                handleSongClick();
                navigate('/account');
                }}>
                </div>
                <img src={scan} alt='scan' className="w-6 ml-2" />
            </div>

            <PopupModal data={displayTextArr} isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen}/>
            <div className="flex justify-center items-center w-full mt-16">
                <Logo />

            </div>
        <div data-modal-target="popup-modal" data-modal-toggle="popup-modal" className="w-full h-8 cursor-pointer z-40 md:w-full flex justify-center  text-center mt-8 mb-1 px-2 py-1"
          onClick={handlePopupToggle}
        >
          <div className="w-full align-middle justify-center text-left overflow-hidden" dir="ltr">
            <div className="w-full text-black/70 font-bold drop-shadow-md dark:text-black whitespace-nowrap">
              <Marquee>
                {displayTextArr.map(d => d.displayText).join(' ')}
              </Marquee>
            </div>
          </div>
        </div>

        <div className="flex py-2 w-full px-1">
            <div className="flex w-full gap-2">
                <div className="w-full h-[10vh] flex flex-col justify-center items-center text-black font-extrabold px-5 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                    style={{
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box'
                    }}
                    onClick={(e) => {
                      handleSongClick().then(() => {
                        navigate('/maungg');
                      });
                    }}
                  >
                    <img className="w-8" src={shoeIcon} alt='shoe'></img>
                    <div className="text-center text-sm xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("maungg")}</div>
                  </div>

                  <div className="w-full h-[10vh] flex flex-col justify-center items-center text-black font-extrabold px-5 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                    style={{
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box'
                    }}
                    onClick={(e) => {
                      handleSongClick().then(() => {
                        navigate('/body');
                      });
                    }}
                  >
                    <img src={football} alt="" className="w-6" />
                    <div className="text-center text-sm mt-2 xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("body")} / {t("totalGoals")}</div>
                  </div>
            </div>
        </div>

        <div className="flex w-full px-1">
          <div className="flex flex-col flex-grow">
            <div className="flex w-full gap-2">
                <div className="z-40 w-full">
                  <div className="w-full h-[10vh] flex justify-between items-center text-black font-extrabold px-1 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                    style={{
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box'
                    }}
                    onClick={(e) => {
                      handleSongClick().then(() => {
                        navigate('/selected-matches');
                      });
                    }}
                  >
                    <div className="flex flex-col w-full justify-center items-center">
                        <img className="w-7" src={onGoing} alt='up-arrow'></img>
                        <div className="text-center text-sm xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("selected")}{t("matches")}</div>
                    </div>
                  </div>
                </div>
                <div className="z-40 w-full">
                  <div className="w-full h-[10vh] flex justify-between items-center text-black font-extrabold px-1 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                    style={{
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box'
                    }}
                    onClick={(e) => {
                      handleSongClick().then(() => {
                        navigate('/old-histories');
                      });
                    }}
                  >
                    <div className="flex flex-col w-full justify-center items-center">
                        <img src={HistoryIco} alt="" className="w-6" />
                        <div className="text-center text-sm xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("oldHistories")}</div>
                    </div>
                  </div>
                </div>
            </div>

          </div>
        </div>

        <div className="w-full flex py-2 px-1">
          <Link className="z-40 w-full">
            <div className="w-full h-[10vh] flex justify-between items-center text-black font-extrabold px-1 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                style={{
                backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box'
                }}
              onClick={(e) => {
                handleSongClick().then(() => {
                  navigate('/goal-score');
                });
              }}
            >
                <div className="flex w-full justify-center items-center">
                    <img className="mr-5 w-8" src={soccer} alt='soccer'></img>
                    <div className="text-center text-sm xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("goalResult")}</div>
                </div>
            </div>
          </Link>
        </div>

        <div className="flex w-full px-1">
            <div className="flex flex-col flex-grow">
                <div className="z-40 w-full">
                  <div className="w-full h-[10vh] flex justify-between items-center text-black font-extrabold px-1 md:px-10 border-2 border-transparent bg-clip-padding rounded-tl-3xl rounded-br-3xl"
                    style={{
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #334155, #334155, #E0BE83)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box'
                    }}
                    onClick={(e) => {
                      handleSongClick().then(() => {
                        navigate('/transactions');
                      });
                    }}
                  >
                    <div className="flex w-full justify-center items-center">
                        <img src={Credit} alt='newspaper' className="mr-5 w-6"></img>
                        <div className="text-center text-sm xs:text-base bg-gradient-to-r from-[#334155] to-[#E0BE83] text-transparent bg-clip-text">{t("transaction")}</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}
export default withAuth(Dashboard);
